import React from 'react';
import { PageHeader, CTASmall } from '../components/PageBits';
import { ASSET } from '../mock/data';
import { Mic2, BookOpen, Heart, Palette } from 'lucide-react';

const programmeAreas = [
  { icon: Mic2, title: 'Leadership and Voice', desc: 'Encouraging women to take active roles in community conversations and decisions.' },
  { icon: BookOpen, title: 'Skills and Growth', desc: 'Supporting learning opportunities that build confidence, independence, and practical ability.' },
  { icon: Heart, title: 'Wellbeing and Support', desc: 'Creating safe, respectful spaces for listening, sharing, and mutual encouragement.' },
  { icon: Palette, title: 'Culture and Celebration', desc: "Honouring women's creative, cultural, and social contributions." },
];

const Women = () => (
  <>
    <PageHeader kicker="REFOCC Women" title="A collective where women" accent="stand tall and voices are celebrated." intro="The Women's Wing of REFOCC is a vibrant and diverse collective — a tapestry of stories, dreams, and accomplishments. It brings together women from different walks of life with a shared vision: to create a world where women's voices are heard and their contributions are valued." />
    <section className="py-8"><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"><img src={`${ASSET}/gallery-22.jpg`} alt="REFOCC Women" className="w-full rounded-[2rem] aspect-[16/7] object-cover"/></div></section>

    {/* Purpose */}
    <section className="py-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-serif text-3xl md:text-4xl text-refocc-dark mb-6">Purpose</h2>
        <p className="text-refocc-dark/70 leading-relaxed max-w-3xl">REFOCC Women creates meaningful spaces for women to connect, express, lead, learn, and grow. It recognizes that women are central to community strength, cultural continuity, family wellbeing, and social progress.</p>
      </div>
    </section>

    {/* Programme Areas */}
    <section className="py-16 bg-refocc-cream">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-serif text-3xl md:text-4xl text-refocc-dark text-center mb-10">Programme Areas</h2>
        <div className="grid sm:grid-cols-2 gap-6">
          {programmeAreas.map(x => (
            <div key={x.title} className="flex gap-5 bg-white rounded-2xl p-6 border border-refocc-dark/10">
              <div className="w-12 h-12 rounded-full bg-refocc-orange/15 text-refocc-orange flex items-center justify-center shrink-0"><x.icon size={20}/></div>
              <div>
                <div className="font-serif text-xl text-refocc-dark">{x.title}</div>
                <p className="text-sm text-refocc-dark/65 mt-2 leading-relaxed">{x.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="py-16 text-center">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-serif text-3xl md:text-4xl text-refocc-dark mb-5">Join the circle</h2>
        <p className="text-refocc-dark/70 mb-8">Whether you'd like to join, host a workshop, or sponsor a programme — we'd love to hear from you.</p>
        <CTASmall label="Join the circle" />
      </div>
    </section>
  </>
);

export default Women;
